module.exports = __webpack_public_path__ + "img/VP-ECONew-Overview.adf63834.jpg";